import { Card } from "primereact/card"
import "./style.css"

export default function CardInformation(props){
    return(
        <Card title={props.title}  footer={props.footer} >
            <span>{props.value}</span>
        </Card>
    )
}